import { render, staticRenderFns } from "./EcommercePieChart.vue?vue&type=template&id=54d7f9bd&"
import script from "./EcommercePieChart.vue?vue&type=script&lang=js&"
export * from "./EcommercePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports